import { render, staticRenderFns } from "./uploadForm.vue?vue&type=template&id=e87037d4&scoped=true&"
import script from "./uploadForm.vue?vue&type=script&lang=js&"
export * from "./uploadForm.vue?vue&type=script&lang=js&"
import style0 from "./uploadForm.vue?vue&type=style&index=0&id=e87037d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87037d4",
  null
  
)

export default component.exports